import React, { FC } from 'react';
import { useIntl } from 'react-intl';
import { RSNote } from 'src/reservation-page/RSNote';
import { buildUrl } from 'src/utils/request-url';

export const NotEndUserProfileWarning: FC = () => {
  const intl = useIntl();

  return (
    <div className="mx-auto max-w-[560px] px-2 pt-2">
      <RSNote
        variant="capital"
        body={
          <>
            {intl.formatMessage(
              { id: 'notEndUserProfileWarning.message' },
              {
                link: (
                  <a
                    href={buildUrl('/u/settings', 'absolute')}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="underline"
                  >
                    {intl.formatMessage({
                      id: 'notEndUserProfileWarning.settingsLink',
                    })}
                  </a>
                ),
              },
            )}
            {'\n'}
            {intl.formatMessage({
              id: 'notEndUserProfileWarning.reservationDisabled',
            })}
          </>
        }
      />
    </div>
  );
};
